import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter} from "react-router-dom";
import Login from './pages/Login';
import reportWebVitals from './reportWebVitals';
import Verify from "./pages/Verify";
import ForgotPassword from "./pages/ForgotPassword";
import ValidateOtp from "./pages/ValidateOtp"
import ResetPassword from "./pages/ResetPassword";
import SetupOtp from "./pages/SetupOtp";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <Routes>
          <Route index element={ <Login/> } />
          <Route path="/" element={ <Login/> } />
          <Route path="verify" element={ <Verify/> } />
          <Route path="forgot" element={ <ForgotPassword/> } />
          <Route path="validate" element={ <ValidateOtp/> } />
          <Route path="reset" element={ <ResetPassword/> } />
          <Route path="setup" element={ <SetupOtp/> } />
      </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
